
















































import { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config';

import Vue from 'vue';

import { ResultMappingIdEnum } from '../../enums';

import { UiSelect, UiTextbox } from '../keen-ui';
import ResultMappingsCard from './result-mappings-card.component.vue';

export default {
  name: 'result-mappings-form',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    ResultMappingsCard,
    UiSelect,
    UiTextbox
  },
  computed: {
    mappingSelectOptions: function (): string[] {
      return !!this.instance.catalog.fields ? this.instance.catalog.fields.map((field: CatalogFieldConfig) => field.id) : [];
    },
    optionalMappingSelectOptions: function (): string[] {
      return !!this.mappingSelectOptions.length ? [this.messages.none].concat(this.mappingSelectOptions) : this.mappingSelectOptions;
    }
  },
  data: function () {
    return {
      messages: this.$epb.messages.tools.instances.fields.catalog.resultMappings,
      ResultMappingIdEnum
    };
  },
  methods: {
    isMappingValueValid: function (mappingId: ResultMappingIdEnum): boolean {
      if ((mappingId === ResultMappingIdEnum.URL_PREFIX) || (mappingId === ResultMappingIdEnum.IMAGE_URL_PREFIX)) {
        return true;
      } else {
        return this.instance.catalog.fields.some(
          (field: CatalogFieldConfig) => (field.id === this.instance.catalog.resultMappings[mappingId]));
      }
    },
    getMappingValue: function (mappingId: ResultMappingIdEnum): string {
      return (this.instance.catalog.resultMappings[mappingId] || '');
    },
    setMappingValue: function (mappingId: ResultMappingIdEnum, value: string): void {
      if (value === this.messages.none) {
        Vue.delete(this.instance.catalog.resultMappings, mappingId);
      } else {
        Vue.set(this.instance.catalog.resultMappings, mappingId, value);
      }
    }
  },
  watch: {
    'instance.catalog.fields': function (): void {
      Object.keys(this.instance.catalog.resultMappings).forEach((mappingId: ResultMappingIdEnum) => {
        if (!this.isMappingValueValid(mappingId)) {
          Vue.delete(this.instance.catalog.resultMappings, mappingId);
        }
      });
    }
  }
};

